<template>
  <div class="block-title">
    <div class="label">
      <div v-if="!iconTitle && title" class="item-line" />
      <div v-if="title" :class="['title-containe', iconTitle ? 'icon-title' : '']">
        <div v-if="iconTitle" class="icon">
          {{ iconTitle }}
        </div>
        <h2 class="title" v-text="title" />
        <span class="sub-title" v-text="subTitle || ''" />
      </div>
      <div v-if="showLine" class="line" />
      <slot name="icon-right"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BlockTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    showLine: {
      type: Boolean,
      default: true,
    },
    iconTitle: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
.block-title {
  .label {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
  }
  .title-containe {
    margin-left: 8px;
    display: flex;
    align-items: center;
    &.icon-title {
      margin-left: 0;
      .title {
        font-size: 16px;
      }
    }
    .sub-title {
      color: #A9ABAE;
      margin-left: 8px;
    }
    .icon {
      margin-right: 8px;
      font-size: 12px;
      font-weight: 500;
      width: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 4px;
      color: #fff;
    }
    .title {
      font-size: 18px;
    }
  }
  .item-line {
    width: 4px;
    height: 16px;
    background: #06B880;
    border-radius: 2px;
  }
  .line {
    border-top: 1px solid #E7E9EC;
    height: 1px;
    width: 100%;
    flex: 1;
    margin-left: 12px;
  }
}
</style>
